import React, { Component, Fragment } from "react";
import {
  ContainerLeft,
  ContainerRight,
  Loader,
  Page,
  Tabs,
} from "components/layouts";
import infraMonitorService from "api/infraMonitorService";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  commonLocalization,
  currency,
  detailLocalization,
  number,
} from "localization";
import styled from "styled-components";
import {
  projectRoadType,
  implementationModal,
  projectStats,
} from "../../../config/localProjects";

class LocalProjectDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
      loading: true,
    };
    this.ref = React.createRef();
    this.municipality = props.municipality;
  }

  componentDidMount() {
    infraMonitorService
      .getLocalProjectDetail(
        this.props.match.params.id,
        this.municipality.title_en
      )
      .then((response) => {
        this.setState({
          detail: response.data,
          loading: false,
        });
      })
      .catch((response) => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { detail, loading } = this.state;
    const { selectedLanguage } = this.props;
    const localizationDetail = detailLocalization[selectedLanguage];

    if (loading) {
      return <Loader />;
    }

    return (
      <Fragment>
        <Page className=''>
          <ContainerLeft>
            <LeftSection
              className='left-section'
              innerRef={this.ref}
              lang={selectedLanguage}
            >
              <div className='mb-8 flex justify-between items-center gap-4'>
                <h1 className='main-title'>
                  {selectedLanguage === "en"
                    ? detail && detail.title_en
                    : detail && detail.title_np}
                </h1>
                <Link to='/local-projects' className='back-to-projects'>
                  <span>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='12'
                      height='12'
                    >
                      <path fill='currentColor' d='m8 12 6-6v12l-6-6Z' />
                    </svg>
                  </span>
                  {localizationDetail.backToProjects}
                </Link>
              </div>
              <table className='local-project-table'>
                <tbody>
                  <tr>
                    <td>{localizationDetail.projectNameInNepali}</td>
                    <td data-cell={localizationDetail.projectNameInNepali}>
                      {detail.title_np || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.projectNameInEnglish}</td>
                    <td data-cell={localizationDetail.projectNameInEnglish}>
                      {detail.title_en || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.typeOfProject}</td>
                    <td data-cell={localizationDetail.typeOfProject}>
                      {selectedLanguage === "en"
                        ? detail.type_name.title_en
                        : detail.type_name.title_ne || "-"}
                    </td>
                  </tr>
                  {detail.type === "road" && (
                    <Fragment>
                      <tr>
                        <td>{localizationDetail.typeOfRoadProject}</td>
                        <td data-cell={localizationDetail.typeOfRoadProject}>
                          {(() => {
                            let metadata = {};
                            try {
                              metadata = JSON.parse(detail.metadata || "{}");
                            } catch (e) {}

                            const roadType = projectRoadType.find(
                              (item) => item.value === metadata.name
                            );

                            if (roadType) {
                              return selectedLanguage === "en"
                                ? roadType.text_en
                                : roadType.text_ne;
                            }

                            return "-";
                          })()}
                        </td>
                      </tr>
                      <tr>
                        <td>{localizationDetail.roadLength}</td>
                        <td data-cell={localizationDetail.roadLength}>
                          {(() => {
                            let metadata = {};
                            try {
                              metadata = JSON.parse(detail.metadata || "{}");
                            } catch (e) {}
                            return number(metadata.roadLength) || "-";
                          })()}
                        </td>
                      </tr>
                    </Fragment>
                  )}
                  {detail.type === "bridge" && (
                    <Fragment>
                      <tr>
                        <td>{localizationDetail.bridgeLength}</td>
                        <td data-cell={localizationDetail.bridgeLength}>
                          {(() => {
                            let metadata = {};
                            try {
                              metadata = JSON.parse(detail.metadata || "{}");
                            } catch (e) {}
                            return number(metadata.bridgeLength) || "-";
                          })()}
                        </td>
                      </tr>
                    </Fragment>
                  )}
                  <tr>
                    <td>
                      {localizationDetail.wardWhereTheProjectWillBeImplemented}
                    </td>
                    <td
                      data-cell={
                        localizationDetail.wardWhereTheProjectWillBeImplemented
                      }
                    >
                      {number(detail.ward) || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.durationOfProject}</td>
                    <td data-cell={localizationDetail.durationOfProject}>
                      {detail.duration
                        ? `${number(detail.duration)} ${
                            detail.duration <= 1
                              ? localizationDetail.month
                              : localizationDetail.months
                          }`
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.estimatedCostForTheProject}</td>
                    <td
                      data-cell={localizationDetail.estimatedCostForTheProject}
                    >
                      {detail.estimated_cost
                        ? currency(detail.estimated_cost)
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.implementationModel}</td>
                    <td data-cell={localizationDetail.implementationModel}>
                      {(() => {
                        const model = implementationModal.find(
                          (item) => item.value === detail.implementation_model
                        );

                        if (model) {
                          return selectedLanguage === "en"
                            ? model.text_en
                            : model.text_ne;
                        }

                        return "-";
                      })()}
                    </td>
                  </tr>

                  <tr>
                    <td>{localizationDetail.uploadedWardOfficeDocument}</td>
                    <td
                      data-cell={localizationDetail.uploadedWardOfficeDocument}
                    >
                      {Array.isArray(detail.mainDocuments) &&
                      detail.mainDocuments.length > 0 ? (
                        <ul>
                          {detail.mainDocuments.map((doc, index) => (
                            <li key={index}>
                              <a
                                href={doc.local_project_file_url}
                                download={
                                  doc.metadata && doc.metadata.filename_original
                                    ? doc.metadata.filename_original
                                    : "document"
                                }
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                {doc.metadata && doc.metadata.filename_original
                                  ? doc.metadata.filename_original
                                  : "Download Document"}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{localizationDetail.status}</td>
                    <td data-cell={localizationDetail.status}>
                      {(() => {
                        const statusItem = projectStats.find(
                          (item) => item.value === detail.status
                        );

                        if (statusItem) {
                          return selectedLanguage === "en"
                            ? statusItem.text_en
                            : statusItem.text_ne;
                        }

                        return "-";
                      })()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </LeftSection>
          </ContainerLeft>
        </Page>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.infraMonitor.projects,
  pagination: state.infraMonitor.pagination,
  stats: state.infraMonitor.stats,
  fetching: state.infraMonitor.fetching,
  filters: state.infraMonitor.filters,
  selectedLanguage: state.localizationReducers.selectedLanguage,
  fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
  loading: state.staticData.loading,
});

export default connect(mapStateToProps)(LocalProjectDetail);

const LeftSection = styled.div`
  padding-bottom: 30px;
  .back-to-projects {
    color: var(--color-theme-1);
    text-decoration: none;
    border-bottom: 1px solid var(--color-theme-1);
    float: right;
    font-size: ${(props) => (props.lang === "en" ? "12px" : "13px")};
    line-height: 16px;
    opacity: 0.7;
    position: relative;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;

    svg {
      width: 10px;
    }
    &:hover {
      opacity: 1;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/localProject/detail/index.js